/* eslint-disable no-nested-ternary */
/* eslint-disable import/no-unused-modules */
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import PrevIcon from '@mui/icons-material/KeyboardArrowLeft';
import NextIcon from '@mui/icons-material/KeyboardArrowRight';
import React, { useState } from 'react';
import Carousel from 'react-multi-carousel';
import useWindowSize from 'react-use/lib/useWindowSize';
import CarouselCardItem from './CarouselCardItem';
import CarouselCountryItem from './CarouselCountryItem';
import CarouselItem from './CarouselItem';
import CarouselLargeItem from './CarouselLargeItem';
import EasyEmoji from '/components/emoji';
import emojiFlags from 'emoji-flags';

export default function TopicCarousel({
  carouselTopic,
  isCountryItem,
  webpSupport,
  isCardItem,
  isLargeItem,
  noMore,
  moreHref,
}) {
  const { posts, title, countryCode, emoji } = carouselTopic;

  const { width } = useWindowSize();

  const startPosts = [];
  posts.forEach((post, i) => {
    if (i < 9) startPosts.push(post);
  });

  const [postsToShow, setPostsToShow] = useState(startPosts);

  const showAllPosts = () => {
    setPostsToShow(posts);
  };

  const ButtonGroup = ({ next, previous, ...rest }) => {
    const {
      carouselState: { currentSlide },
    } = rest;
    return (
      <>
        <div
          className="d-absolute"
          style={{
            marginTop:
              isCountryItem || isLargeItem ? -358 : isCardItem ? -298 : -345,
            height: isCountryItem || isLargeItem ? 350 : isCardItem ? 290 : 320,
          }}
        >
          <div className="d-flex align-items-center h-100 w-100">
            <div>
              {currentSlide === 0 ? (
                <></>
              ) : (
                <IconButton
                  color="primary"
                  onClick={() => previous()}
                  aria-label="Previous"
                  size="large"
                >
                  <PrevIcon />
                </IconButton>
              )}
            </div>
          </div>
        </div>
        <div
          className="d-absolute"
          style={{
            marginTop:
              isCountryItem || isLargeItem ? -350 : isCardItem ? -290 : -320,
            height: isCountryItem || isLargeItem ? 350 : isCardItem ? 290 : 320,
            marginBottom: isCountryItem || isLargeItem || isCardItem ? 0 : 30,
          }}
        >
          <div className="d-flex justify-content-end h-100 align-items-center">
            <div>
              <IconButton
                color="primary"
                onClick={() => {
                  next();
                  showAllPosts();
                }}
                aria-label="Next"
                size="large"
              >
                <NextIcon />
              </IconButton>
            </div>
          </div>
        </div>
      </>
    );
  };

  const responsive = {
    desktop: {
      breakpoint: { max: 10000, min: 1200 },
      items: 4,
    },
    smallDesktop: {
      breakpoint: { max: 1199, min: 940 },
      items: 3,
    },
    tablet: {
      breakpoint: { max: 939, min: 600 },
      items: 2,
    },
    mobile: {
      breakpoint: { max: 599, min: 0 },
      items: 1,
    },
  };
  let itemsToScroll = 1;
  if (width > 599) itemsToScroll = 2;
  if (width > 939) itemsToScroll = 3;
  if (width > 1199) itemsToScroll = 4;
  const responsiveCountryItem = {
    superLargeDesktop: {
      breakpoint: { max: 10000, min: 1750 },
      items: 4,
    },
    desktop: {
      breakpoint: { max: 1749, min: 1150 },
      items: 3,
    },
    tablet: {
      breakpoint: { max: 1149, min: 550 },
      items: 2,
    },
    mobile: {
      breakpoint: { max: 549, min: 0 },
      items: 1,
    },
  };
  let countryItemsToScroll = 1;
  if (width > 549) countryItemsToScroll = 2;
  if (width > 1149) countryItemsToScroll = 3;
  if (width > 1749) countryItemsToScroll = 4;
  let responsiveLargeItem = {
    mobile: {
      breakpoint: { max: 10000, min: 0 },
      items: 1,
    },
  };
  if (posts.length > 1)
    responsiveLargeItem = {
      tablet: {
        breakpoint: { max: 10000, min: 850 },
        items: 2,
      },
      mobile: {
        breakpoint: { max: 849, min: 0 },
        items: 1,
      },
    };
  const largeItemsToScroll = 1;

  return (
    <div className="pt-2">
      <Typography
        gutterBottom
        variant="h4"
        component="h2"
        className={`font-weight-bold ${
          isCountryItem ? 'text-center' : 'tw-ml-5'
        }`}
        style={{ paddingLeft: 35, paddingRight: 35 }}
        color="textPrimary"
      >
        {emoji && EasyEmoji(emoji)}
        {countryCode &&
          EasyEmoji(
            emojiFlags.countryCode(countryCode.toUpperCase()).emoji,
          )}{' '}
        {title}
      </Typography>
      <div
        style={{
          minHeight: isCountryItem ? '350px' : '320px',
        }}
      >
        <Carousel
          responsive={
            isCountryItem
              ? responsiveCountryItem
              : isLargeItem
              ? responsiveLargeItem
              : responsive
          }
          draggable={false}
          itemClass="p-2"
          slidesToSlide={
            isCountryItem
              ? countryItemsToScroll
              : isLargeItem
              ? largeItemsToScroll
              : itemsToScroll
          }
          arrows={false}
          customButtonGroup={<ButtonGroup />}
          renderButtonGroupOutside
          containerClass="mx-5"
        >
          {postsToShow.map((post, i) => {
            if (isCountryItem)
              return (
                <CarouselCountryItem
                  webpSupport={webpSupport}
                  post={post}
                  isLastItem={i === posts.length - 1}
                />
              );
            if (isCardItem) {
              return <CarouselCardItem key={post.heading} post={post} />;
            }
            if (isLargeItem)
              return (
                <CarouselLargeItem webpSupport={webpSupport} post={post} />
              );
            return (
              <CarouselItem
                key={`${post.author.username}/${post.permlink}`}
                webpSupport={webpSupport}
                post={post}
                isLastItem={noMore ? undefined : i === posts.length - 1}
                moreHref={moreHref}
              />
            );
          })}
        </Carousel>
      </div>
    </div>
  );
}
